import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  postPaymentSubscriptionRoute,
  errorMessage,
  currentPlanKey,
  addPaymentInformationRoute,
  paymentMethodsKey,
  paymentDetails,
  deletePaymentInformationRoute,
  setDefaultPaymentInformationRoute,
} from '@features/payments';
import axiosInstance from '@server/axiosInstance';

type useSetDefaultPaymentMethodProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
  onSuccess?: () => void;
};

export const useSetDefaultPaymentMethod = ({
  setErrorText = () => { },
  onSuccess = () => { },
}: useSetDefaultPaymentMethodProps) => {
  const client = useQueryClient();

  const {
    mutate: setDefaultPaymentMethod,
    isLoading: iseSettingDefaultPaymentMethod,
  } = useMutation({
    mutationFn: (variables: { payment_id: string, customer_id: string, }) =>
      axiosInstance
        .post(setDefaultPaymentInformationRoute, variables)
        .then((res) => res.data),
    onSuccess: (data) => {
      if (data.status !== 200) {
        setErrorText(data.message);
      } else {
        setErrorText('');
        onSuccess();
        client.invalidateQueries([currentPlanKey]);
        client.invalidateQueries([paymentMethodsKey]);
        client.invalidateQueries([paymentDetails]);
      }
    },
    onError: () => setErrorText(errorMessage),
  });

  return {
    setDefaultPaymentMethod,
    iseSettingDefaultPaymentMethod,
  };
};
